import React, { useState } from 'react';
import SearchInput from 'src/components/search-input/search-input';
import { useGetOrganizationClientsQuery } from 'src/redux/organization/organization.endpoints';
import { useGetCompaniesQuery } from 'src/pages/billing/endpoints/billing.endpoints';
import { Button } from 'src/components/ui/button';
import { Plus } from 'lucide-react';
import ManageClientsTable from '../components/manage-clients/manage-clients-table';
import { Client } from '../types/client.types';
import { ManageClientDrawer } from '../components/manage-clients/manage-client-drawer';
import CreateClientModal from '../components/manage-clients/create-client-modal';
import { useActiveClient } from 'src/redux/active-client/use-active-client';

const ManageClientsTab: React.FC = () => {
  const { setClient } = useActiveClient();
  const [showClientDrawer, setShowClientDrawer] = useState(false);
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [searchValue, setSearchValue] = useState('');

  const { data: clients, isLoading: isLoadingClients, isFetching: isFetchingClients } = useGetOrganizationClientsQuery();
  const { data: companies = [] } = useGetCompaniesQuery();

  const handleClientSelect = (client: Client) => {
    setClient(client);
    setShowClientDrawer(true);
  };

  const handleClientCreated = (client: Client) => {
    setClient(client);
    setShowClientDrawer(true);
  };

  return (
    <>
      <div className="h-full flex flex-col space-y-4">
        <div className="">
          <div className="flex flex-row gap-4 w-full items-center justify-between pb-1">
            <div>
              <SearchInput
                placeholder="Search clients..."
                value={searchValue}
                onChange={setSearchValue}
                debounceMs={500}
                className="w-96 rounded-full"
                inputClassName='bg-white rounded-full '
              />
            </div>
          </div>
        </div>

        <div className="overflow-auto relative rounded-lg shadow-md bg-white">
          <div className='flex flex-row gap-2 justify-end bg-white border-b border-gray-201'>
            <Button
              size='med'
              variant='ghost'
              onClick={() => setShowCreateModal(true)}
              className="flex flex-col hover:bg-gray-201 rounded-none p-8 px-4 pb-8 text-sm gap-1 border-l border-gray-201"
            >
              <Plus className="h-4 w-4" />
              New
            </Button>
          </div>
          <div className='overflow-visible'>
            <ManageClientsTable
              clients={clients ?? []}
              loading={isLoadingClients || isFetchingClients}
              isCreation={false}
              className='overflow-visible'
              onClientSelect={handleClientSelect}
            />
          </div>
        </div>
      </div>

      <CreateClientModal
        open={showCreateModal}
        companies={companies}
        onOpenChange={setShowCreateModal}
        onSuccess={handleClientCreated}
      />

      <ManageClientDrawer
        open={showClientDrawer}
        onOpenChange={setShowClientDrawer}
      />
    </>
  );
};

export default ManageClientsTab;
